import Inputc from '../../../components/input.vue'
import Page from '../../../components/page.vue'
import {store} from "../../../store/store";
import {api,imgPath} from "../../../common/config";
import {ajaxUtil} from "../../../common/AjaxUtil";
import {CommonUtil} from "../../../common/CommonUtil";
import {StorageUtil} from '../../../common/Auth.js';
import {MD5Util} from '../../../common/MD5Util.js';

export default {
    name: 'borrow',
    components: {
        Inputc,
        Page
    },
    data() {
        return {
          imgPath:imgPath,
            isPay: false,//控制赔书弹出框
            listBook: [],
            idCard: store.func.getUserIdCard(),
            readerId: store.func.getUserReaderId(),
            totalPage: 1,
            imgError: store.imgError,
            depositInfo: {activeDeposit: 0, usedDeposit: 0},
            compensatePrice: 0,
            compensatePriceStr: 0,
            isAgreement: false,//false:无协议；true:有协议；
            isRecharge: false,//false:不充值；true:可充值
            subBorrowId: 0,
            userPwd: "",
            pageCount: 4,
            pageNo: 1,
            borrowType: 1,//0 全部，1 当前借阅，2历史借阅
            typeId: 1   //1新增   2修改
        }
    },
    watch: {
        $route() {
            this.querylist();
        }
    },
    beforeMount() {
        store.personal._this.activeNav = "当前借阅";
        this.querylist();
    },
    methods: {
        querylist() {
            this.pageNo = this.$route.query.page || 1;
            var url = api.readerBorrower.list.replace('{pageNo}', this.pageNo).replace('{pageCount}', this.pageCount)
                .replace('{idCard}', this.idCard).replace('{borrowType}', this.borrowType);
            ajaxUtil.ajaxJson(url, null, "GET", (data) => {
                if (data.resultList != null) {
                    var listBook = data.resultList;
                    //store.personal.changeBorrowNum(data.totalCount);
                    //数据处理
                    for (let i = 0; i < listBook.length; i++) {
                        //修改状态 为中文
                        if (listBook[i].borrowState == 5) {
                            listBook[i].borrowState = "在借";
                        } else if (listBook[i].borrowState == 6) {
                            listBook[i].borrowState = "归还";
                        } else if (listBook[i].borrowState == 7) {
                            listBook[i].borrowState = "赔偿";
                        } else if (listBook[i].borrowState == 28) {
                            listBook[i].borrowState = "逾期购买";
                        }
                        var daysRemaining = listBook[i].daysRemaining;
                        if (daysRemaining >= 0) {
                            if (daysRemaining <= 1) {
                                listBook[i].daysRemainingStr = "今天到期";
                            }
                        } else {
                            listBook[i].daysRemainingStr = "已逾期";
                        }
                    }
                    this.listBook = listBook;
                }
                this.totalPage = data.totalPage;
            }, null, this);
        },
        //翻页操作
        pageChange(pageNo) {
            CommonUtil.mergeQuery(this, {page: pageNo});
        },
        /*打开赔书弹出框*/
        compensation(item) {
            this.userPwd = "";
            var url = api.account.getDepositInfo.replace('{hallCode}', item.libCode).replace('{readerId}', this.readerId);
            ajaxUtil.ajaxJson(url, null, "GET", (data) => {
                this.depositInfo = {
                    activeDeposit: data.activeDeposit, usedDeposit: data.usedDeposit,
                    activeDepositStr: (data.activeDeposit).toFixed(2), usedDepositStr: (data.usedDeposit).toFixed(2)
                };
                this.isPay = true;
                this.compensatePrice = item.compensatePrice;//赔书价格
                this.compensatePriceStr = (item.compensatePrice).toFixed(2);//赔书价格
                if (item.compensatePrice <= this.depositInfo.activeDeposit) {
                    this.isRecharge = true;
                }
                this.subBorrowId = item.id;
                if (item.haveAgreement == 1) {
                    this.isAgreement = true;
                } else if (item.haveAgreement == 0) {
                    this.isAgreement = false;
                }
            }, null, this);

        },
        /*关闭赔书弹出框*/
        del() {
            this.isPay = false
        },
        /*点赞功能*/
        onPraise(index, id) {
            var isPraiseD = this.listBook[index].isPraiseD;
            if (isPraiseD == 0) {
                isPraiseD = 1;
            } else {
                isPraiseD = 0;
            }
            //post
            var url = api.readerBorrower.like;
            var data = {
                borrowerBookId: id,
                praise: isPraiseD,
            };
            ajaxUtil.ajaxJson(url, data, "POST", (data) => {
                this.listBook[index].isPraiseD = isPraiseD;
            }, (result) => {
                CommonUtil.setInfo("点赞失败，请稍后重试!");
            }, this);
        },
        editNote(item) {
          this.$router.push({path: '/editnote', query: { 'bookName': item.bookName, 'bookId': item.bookId, 'typeId': this.typeId }})
        },
        /*续借*/
        onLend(index, mayRenew, id) {
            if (mayRenew == 0) {
                return;
            }
            //post
            var url = api.readerBorrower.renew;
            var data = {
                borrowerBookId: id,
                idCard: this.idCard,
            };

            ajaxUtil.ajaxJson(url, data, "POST", (data) => {
                this.listBook[index].mayRenew = 0;
                this.querylist();
            }, (result) => {
                CommonUtil.setInfo("续借失败，请稍后重试!");
            }, this);
        },
        subCompensationBook() {
            if (this.userPwd.trim() == "") {
                this.$refs.pwdDom.showError("密码不能为空!");
                return;
            }
            if (this.compensatePrice <= this.depositInfo.activeDeposit) {//赔书
                var url = api.account.compensateOneBook.replace('{readerId}', store.user.readerId);
                var data = {
                    borrowerId: this.subBorrowId,
                    idCard: store.user.idCard,
                    idPassword: MD5Util.hex_md5(this.userPwd),
                }
                ajaxUtil.ajaxJson(url, data, "POST", (data) => {
                    this.isPay = false;
                    CommonUtil.setInfo("赔书成功!");
                    window.setTimeout(function () {
                        CommonUtil.changeURLPar({});
                    }, 2000);
                }, (data) => {
                    if (data.errorCode == 3103) {
                        this.$refs.pwdDom.showError("账户密码错误!");
                        return;
                    } else if (data.errorCode == 3401) {
                        this.$refs.pwdDom.showError("无协议客户押金不足，请至图书馆处理!");
                        return;
                    }
                    this.isPay = false;
                    CommonUtil.setInfo("赔书失败!");
                }, this);

            }
        }
    }
}
